import toast from "react-hot-toast";
import { validateEmail, validatePhone, validateRequired, validateZipCode, validateNumeric, validatePercentage, ErrorMessage } from "../../utlis/function";
import { callApi } from "../../services/ApiServices";
import { useGlobalStates } from "../../utlis/ClubsContext";
import { useEffect, useRef, useState } from "react";
import CommonLoader from "../common/CommonLoader";

const AddClubAudienceForm = ({ formData, updateFormData , handleInputChange, errors, setErrors, handleNext, activeStep, steps,setCompletedStep,completedStep, setIsDirty, isDirty}) => {
const{clubId} = useGlobalStates()
const [isLoading, setIsLoading] = useState(false);
  const fieldsRef = useRef({})

const handleFieldValidation = (name, value) => {
  const updatedFormData = {
    ...formData,
    [name]: value,
  };

  const fieldError = validateField(name, value, updatedFormData);

  if (name === "genderMale" || name === "genderFemale") {
    const maleError = validateField(
      "genderMale",
      updatedFormData.genderMale,
      updatedFormData
    );

    const femaleError = validateField(
      "genderFemale",
      updatedFormData.genderFemale,
      updatedFormData
    );

    const genderTotalError = validateGenderTotal(updatedFormData);

    setErrors((prev) => ({
      ...prev,
      genderMale: maleError || genderTotalError,
      genderFemale: femaleError || genderTotalError,
    }));
  } else {
    setErrors((prev) => ({
      ...prev,
      [name]: fieldError,
    }));
  }
};
const validateGenderTotal = (formData) => {
  const male = parseFloat(formData?.genderMale);
  const female = parseFloat(formData?.genderFemale);

  if (!isNaN(male) && !isNaN(female)) {
    if (male + female !== 100) {
      return "Male + Female must equal 100%";
    }
  }

  return "";
};


  const validateField = (name, value, formData) => {
  let error = '';

  switch (name) {
    // Stats Section
    case 'totalMembers':
      if (!validateRequired(value)) error = 'Total members is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'monthlyVisits':
      if (!validateRequired(value)) error = 'Average monthly visits is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'avgHouseholdIncome':
      if (!validateRequired(value)) error = 'Average household income is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'avgDailyVisit':
      if (!validateRequired(value)) error = 'Average daily visit is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'screensAcrossClub':
      if (!validateRequired(value)) error = 'Displays across the club is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'avgDwellTime':
      if (!validateRequired(value)) error = 'Average visit length is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    // Gender Distribution
    case 'genderMale':
      if (!validateRequired(value)) error = 'Male count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'genderFemale':
      if (!validateRequired(value)) error = 'Female count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    // Age Distribution
    case 'ageUnder18':
      if (!validateRequired(value)) error = 'Under age 18 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age18to24':
      if (!validateRequired(value)) error = 'Age 18-24 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age25to34':
      if (!validateRequired(value)) error = 'Age 25-34 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age35to44':
      if (!validateRequired(value)) error = 'Age 35-44 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age45to54':
      if (!validateRequired(value)) error = 'Age 45-54 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age55to64':
      if (!validateRequired(value)) error = 'Age 55-64 count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'age65Plus':
      if (!validateRequired(value)) error = 'Age 65+ count is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    // Performance
    case 'dailyImpressions':
      if (!validateRequired(value)) error = 'Daily visits is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'monthlyImpressions':
      if (!validateRequired(value)) error = 'Monthly visits is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'performanceAvgCPM':
      if (!validateRequired(value)) error = 'Average CPM is required';
      else if (!validateNumeric(value)) error = 'Please enter a valid number';
      break;

    case 'engagementRate':
      if (!validateRequired(value)) error = 'Engagement rate is required';
      else if (!validatePercentage(value))
        error = 'Please enter a valid percentage (0-100)';
      break;

    case 'collegePercentage':
      if (!validateRequired(value)) error = 'College educated Percentage  is required';
      break;

    default:
      break;
  }

  // ⛔ Stop if field-level error exists
  if (error) return error;

  // ✅ Cross-field validation
  if (name === 'genderMale' || name === 'genderFemale') {
    return validateGenderTotal(formData);
  }

  return '';
};

    const validateAllFields = () => {
      let isValid = true;
      const newErrors = {};

      Object.keys(formData).forEach(key => {
        const error = validateField(key, formData[key], formData);
        if (error) {
          newErrors[key] = error;
          isValid = false;
        }
      });
      
      /* ---------------------------
         5️⃣ Set ALL errors once
      ---------------------------- */
      setErrors(prev => ({
        ...prev,
        ...newErrors,
      }));

      return {isValid, newErrors} ;
    };
 const saveFormData = async () => {
        if (!isDirty) {
    toast("No changes to save");
    return;
  }
 
    let data ={
      "clubTotalMembers":formData.totalMembers,
      "clubMonthlyVisits" : formData.monthlyVisits,
      "avgHouseHoldIncome": formData.avgHouseholdIncome,
      "avgDailyVisits": formData.avgDailyVisit,
      "totalScreensCount": formData.screensAcrossClub,
      "avgDwellTime": formData.avgDwellTime, 
      "maleDistribution": formData.genderMale,
      "femaleDistribution": formData.genderFemale,
      "avgDistribUnd18": formData.ageUnder18,
      "avgDistrib18_24": formData.age18to24,
      "avgDistrib25_34":formData.age25to34,
      "avgDistrib35_44":formData.age35to44,
      "avgDistrib45_54":formData.age45to54,
      "avgDistrib55_64":formData.age55to64,
      "avgDistribOver65":formData.age65Plus,
      "dailyImpressions":formData.dailyImpressions,
      "monthlyImpressions":formData.monthlyImpressions,
      "avgCpm":formData.performanceAvgCPM,
      "engagementRate":formData.engagementRate,
      "collegePercentage": formData.collegePercentage
    }
    setIsLoading(true);
    try {
      const response = await callApi({
        method: "put",
        url: `club/audience-performance/${clubId}`,
        data: data,
      });
    if(response.status === 200){
   setCompletedStep((prev)=> Math.max(prev, response?.stepUpdated || 2)) 
           toast.success('Club data saved successfully!', {id:"saveDataToast"});

      setIsDirty(false)
    }
      return response;
    } catch (error) {
      console.error("Error saving club data:", error);
      throw error;
    }finally{
      setIsLoading(false);
    }
  };

    const scrollToFirstError = (errors) => {
  const findError = (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === "string" && obj[key]) {
        return key;
      }
      if (typeof obj[key] === "object") {
        const nested = findError(obj[key]);
        if (nested) return key;
      }
    }
    return null;
  };

  const firstErrorField = findError(errors);

  if (firstErrorField && fieldsRef.current[firstErrorField]) {
    fieldsRef.current[firstErrorField].scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    fieldsRef.current[firstErrorField].focus?.();
  }
};


  const handleSaveWithAPI = async () => {
    const {isValid, newErrors}  = validateAllFields();
  if (!isValid) {
    scrollToFirstError(newErrors);
    return;
  }
    console.log("Final form data:", formData);

    try {
     
     const response = await saveFormData();
     console.log("responseApi", response)
   
    } catch (error) {
      console.error("Error saving club:", error);
    }
    
  };

   const handleNextWithAPI = async () => {
     const { isValid, newErrors } = validateAllFields();
     if (!isValid) {
       scrollToFirstError(newErrors);
       return;
     }
     if (isDirty) {

       console.log("Final form data:", formData);

       try {
         const response = await saveFormData();
         console.log("response", response);
         if (response.status === 200) {
           //response.stepUpdated
           handleNext();
         }
       } catch (error) {
         console.error("Error saving club:", error);
       }
     } else {
       handleNext();
     }
   };

  return (
    <div className="space-y-6">
      {isLoading && <CommonLoader fullScreen/>}
      {/* Stats Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
          Stats
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Key attendance and audience size metrics for this location.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Total Members */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Total Members
            </label>
            <input
            ref={(el)=>(fieldsRef.current.totalMembers = el)}
              type="number"
              placeholder="Enter total members"
              value={formData.totalMembers || ''}
              name="totalMembers"
              onChange={(e) => {
                const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.totalMembers ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.totalMembers} />
          </div>

          {/* Monthly Visits */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
             Avgerage Monthly Visits
            </label>
            <input
            ref={(el)=>(fieldsRef.current.monthlyVisits = el)}
              type="number"
              placeholder="Enter monthly visits"
              value={formData.monthlyVisits || ''}
              name="monthlyVisits"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.monthlyVisits ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.monthlyVisits} />
          </div>

          {/* Avg. Household Income */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Avg. Household Income
            </label>
            <input
            ref={(el)=>(fieldsRef.current.avgHouseholdIncome = el)}
              type="number"
              placeholder="Enter avg. household income"
              value={formData.avgHouseholdIncome || ''}
              name="avgHouseholdIncome"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.avgHouseholdIncome ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.avgHouseholdIncome} />
          </div>

          {/* Average Daily Visit */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Average Daily Visit
            </label>
            <input
            ref={(el)=>(fieldsRef.current.avgDailyVisit = el)}
              type="number"
              placeholder="Enter avg. daily visit"
              value={formData.avgDailyVisit || ''}
              name="avgDailyVisit"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.avgDailyVisit ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.avgDailyVisit} />
          </div>

          {/* Screens Across the Club */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Displays
            </label>
            <input
            ref={(el)=>(fieldsRef.current.screensAcrossClub = el)}
              type="number"
              placeholder="Enter displays across the club"
              value={formData.screensAcrossClub || ''}
              name="screensAcrossClub"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.screensAcrossClub ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.screensAcrossClub} />
          </div>

          {/* Average Dwell Time */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Average Visit Length
            </label>
            <input
            ref={(el)=>(fieldsRef.current.avgDwellTime = el)}
              type="text"
              placeholder="Enter avg. visit Length"
              name="avgDwellTime"
              value={formData.avgDwellTime || ''}
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.avgDwellTime ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.avgDwellTime} />
          </div>
        </div>
      </div>

      {/* Gender Distribution Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
          Gender Distribution
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Breakdown of your audience by gender for better targeting.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Male */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Male (%)
            </label>
            <input
            ref={(el)=>(fieldsRef.current.genderMale = el)}
              type="number"
              placeholder="Enter total male percentage"
              value={formData.genderMale || ''}
              name="genderMale"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.genderMale ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.genderMale} />
          </div>

          {/* Female */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Female (%)
            </label>
            <input
            ref={(el)=>(fieldsRef.current.genderFemale = el)}
              type="number"
              placeholder="Enter total female percentage"
              value={formData.genderFemale || ''}
              name="genderFemale"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.genderFemale ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.genderFemale} />
          </div>
        </div>
      </div>

      {/* Avg. Distribution Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
          Avg. Distribution
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Audience age segmentation to understand your primary viewer groups.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Under age 18 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Under age 18
            </label>
            <input
            ref={(el)=>(fieldsRef.current.ageUnder18 = el)}
              type="number"
              placeholder="Enter count"
              value={formData.ageUnder18 || ''}
              name="ageUnder18"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.ageUnder18 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.ageUnder18} />
          </div>

          {/* 18-24 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              18-24
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age18to24 = el)}
              type="number"
              placeholder="Enter count"
              name="age18to24"
              value={formData.age18to24 || ''}
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age18to24 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age18to24} />
          </div>

          {/* 25-34 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              25-34
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age25to34 = el)}
              type="number"
              placeholder="Enter count"
              value={formData.age25to34 || ''}
              name="age25to34"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age25to34 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age25to34} />
          </div>

          {/* 35-44 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              35-44
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age35to44 = el)}
              type="number"
              placeholder="Enter count"
              value={formData.age35to44 || ''}
              name="age35to44"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age35to44 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age35to44} />
          </div>

          {/* 45-54 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              45-54
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age45to54 = el)}
              type="number"
              placeholder="Enter count"
              value={formData.age45to54 || ''}
              name="age45to54"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age45to54 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age45to54} />
          </div>

          {/* 55-64 */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              55-64
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age55to64 = el)}
              type="number"
              placeholder="Enter count"
              value={formData.age55to64 || ''}
              name="age55to64"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age55to64 ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age55to64} />
          </div>

          {/* Age65+ */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Age65+
            </label>
            <input
            ref={(el)=>(fieldsRef.current.age65Plus = el)}
              type="number"
              placeholder="Enter count"
              value={formData.age65Plus || ''}
              name="age65Plus"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.age65Plus ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.age65Plus} />
          </div>
        </div>
      </div>

      {/* Performance Section */}
      <div className="bg-white rounded-xl p-6 main-shadow">
        <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
          Performance
        </h2>
        <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
          Ad delivery and effectiveness metrics for this venue.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Daily Impressions */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Daily Visits
            </label>
            <input
            ref={(el)=>(fieldsRef.current.dailyImpressions = el)}
              type="number"
              placeholder="Enter count"
              name="dailyImpressions"
              value={formData.dailyImpressions || ''}
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.dailyImpressions ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.dailyImpressions} />
          </div>

          {/* Monthly Impressions */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Monthly Visits
            </label>
            <input
            ref={(el)=>(fieldsRef.current.monthlyImpressions = el)}
              type="number"
              placeholder="Enter count"
              value={formData.monthlyImpressions || ''}
              name="monthlyImpressions"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.monthlyImpressions ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.monthlyImpressions} />
          </div>

          {/* Average CPM */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Average CPM
            </label>
            <input
            ref={(el)=>(fieldsRef.current.performanceAvgCPM = el)}
              type="number"
              placeholder="Enter count"
              value={formData.performanceAvgCPM || ''}
              name="performanceAvgCPM"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.performanceAvgCPM ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.performanceAvgCPM} />
          </div>

          {/* Engagement Rate */}
          <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
              Engagement Rate
            </label>
            <input
            ref={(el)=>(fieldsRef.current.engagementRate = el)}
              type="number"
              placeholder="Enter count"
              value={formData.engagementRate || ''}
              name="engagementRate"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.engagementRate ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.engagementRate} />
          </div>

               <div>
            <label className="block text-small font-medium text-black tracking-[0] leading-[normal] mb-2">
             College Educated(%)
            </label>
            <input
            ref={(el)=>(fieldsRef.current.collegePercentage = el)}
              type="number"
              placeholder="Enter Percentage"
              value={formData.collegePercentage || ''}
              name="collegePercentage"
              onChange={(e) => {
                 const value = e.target.value
                if(value.length > 10) return
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border focus:outline-none focus:border-primary transition-colors ${
                errors.collegePercentage ? 'border-red-500' : 'border-gray-200'
              }`}
            />
            <ErrorMessage message={errors.collegePercentage} />
          </div>
        </div>
      </div>
       <div className="flex items-center justify-between mt-6">
          <button
            onClick={handleSaveWithAPI}
            disabled={isLoading}
            className="cursor-pointer px-2 h-[60px] w-[200px] border border-primary text-primary font-medium text-lg rounded-full transition-colors hover:bg-primary hover:text-white"
           
          >
            Save
          </button>
          <button
            onClick={handleNextWithAPI}
            disabled={isLoading}
            className="cursor-pointer px-2 h-[60px] w-[200px] border bg-primary hover:bg-hover text-white rounded-full text-primary font-medium text-lg transition-colors"
          >
            {activeStep === steps.length - 1 ? 'Save' : 'Next'}
          </button>
        </div>
    </div>
  );
};

export default AddClubAudienceForm;
